<template lang="html">
  <div id="Home">
    <svg id="Cover" :viewBox="`0 0 ${coverWidth} ${coverHeight}`">
      <g
        ref="image"
        :transform-origin="`${coverWidth/2} ${coverHeight/2}`"
        :style="{transformOrigin: `${coverWidth/2} ${coverHeight/2}`}">
        <foreignObject x="0" y="0" :width="coverWidth" :height="coverHeight">
          <picture>
            <source :srcset="`${publicPath}scenes/cover/main-bg-480w.jpg`" media="(max-width: 480px)">
            <source :srcset="`${publicPath}scenes/cover/main-bg-768w.jpg`" media="(max-width: 768px)">
            <img :style="{width: `100%`, height: `auto`}" :src="`${publicPath}scenes/cover/main-bg.jpg`" />
          </picture>
        </foreignObject>
      </g>

      <g class="title" transform="translate(440 280)" ref="title">
        <text fill="#0A0A0A" font-size="95" font-weight="bold" class="minion bold">Max Littlesalt</text>
        <text fill="#0A0A0A" font-size="48" y="55" x="110" class="minion bold">A Graphic Biography</text>
      </g>

      <line ref="divider"
            x1="425" x2="950" y1="380" y2="380"
            stroke-width="1" stroke="black" />

      <g class="credit" transform="translate(470 450)" ref="byline">
        <text x="0" y="0" fill="black" font-size="40" class="minion italic">Created by The ONWARD Project</text>
      </g>

      <g @click="begin" class="cta" transform="translate(580 500)" ref="cta">
        <clipPath id="cta-clip">
          <rect width="360" height="72" fill="black"></rect>
        </clipPath>
        <rect rx="36" fill="white" width="360" height="72" stroke="black" />
        <text
          text-anchor="middle" fill="black" font-size="30" font-weight="bold"
          dominant-baseline="middle" alignment-baseline="middle" dx="180"
          dy="39" class="minion">CLICK TO BEGIN</text>

        <g clip-path="url(#cta-clip)">
          <rect rx="36" fill="#E38900" width="360" height="72" stroke="black" />
          <text
            text-anchor="middle" fill="white" font-size="30" font-weight="bold"
            dominant-baseline="middle" alignment-baseline="middle" dx="180"
            dy="39" class="minion">CLICK TO BEGIN</text>
        </g>
      </g>
    </svg>
    <div id="HomeMask" ref="mask" :style="{display: mask ? 'block' : 'none'}"></div>
  </div>
</template>

<script>
import { mapActions } from "vuex"
import { TimelineMax, TweenMax, CSSPlugin } from "gsap"

const plugins = [ CSSPlugin ]

function prepText(...texts) {
  const svgns = "http://www.w3.org/2000/svg"
  texts.forEach(t => {
    const tspans = Array.from(t.children)
    tspans.forEach(ts => {
      let prevDims = null
      const text = ts.textContent
      const fontSize = ts.getAttribute("font-size")
      const className = ts.className.baseVal
      const fill = ts.getAttribute("fill")
      const yBase = ts.getAttribute("y")
      const xBase = ts.getAttribute("x")
      ts.textContent = ""
      for (let l of text) {
        let space = l.charCodeAt(0) === 32
        let n = document.createElementNS(svgns, "text")
        n.setAttribute("font-size", fontSize)
        n.setAttribute("fill", fill)
        if (space) { n.setAttribute("opacity", 0) }
        if (yBase) { n.setAttribute("y", yBase) }
        if (xBase) { n.setAttribute("x", xBase) }
        if (prevDims) {
          n.setAttribute("x", prevDims.x + prevDims.width + 0.5) // extra space needed?
        }
        n.textContent = space ? "l" : l
        n.setAttribute("class", className)
        t.appendChild(n)
        prevDims = n.getBBox()
      }
      t.removeChild(ts)
    })
  })
}

function fetchChars(parent) {
  return Array.from(parent.children)
}

function random(min, max){
    return (Math.random() * (max - min)) + min;
}

export default {
  data: () => ({
    publicPath: process.env.BASE_URL,
    coverWidth: 1000,
    coverHeight: 720,
    mask: true,
    tl: null,
  }),
  computed: {
    first() { return this.$store.getters.slide(0).slug },
  },
  methods: {
    ...mapActions([
      "setCurrent",
    ]),
    begin() {
      this.$router.push("/how-to")
    },
  },
  mounted() {
    this.setCurrent(this.first)

    const { image, title, byline, cta, divider } = this.$refs
    let imageIn = 2
    this.tl = new TimelineMax()
    this.tl.set([image, cta, title, divider, byline].flat(), {
      opacity: 0,
      onComplete: () => this.mask = false
    })
    this.tl.add(TweenMax.fromTo(image, imageIn,
      { scale: 1.2, opacity: 0, transformOrigin: `${this.coverWidth/2}px ${this.coverHeight/2}px`, },
      { scale: 1, opacity: 1 }))
    this.tl.add(TweenMax.fromTo(divider, 1,
      { scaleX: 0, opacity: 1, transformOrigin: "bottom right" },
      { scaleX: 1, opacity: 1, }), imageIn/2)
    this.tl.add(TweenMax.to(title, 1.5, { opacity: 1 }))
    this.tl.add(TweenMax.to(byline, 1.5, { opacity: 1 }), "-=1")
    this.tl.add(TweenMax.to(cta, 1, {opacity: 1}), "-=1")
  }
}
</script>

<style lang="scss">
#Cover {
  position: absolute; top: 0; left: 0; width: 100%; height: 100%;

  .cta {
    cursor: pointer;
    #cta-clip rect {
      transform: scaleX(0);
      transform-origin: 360px 0px;
      transition: transform 0.4s ease; }
    &:hover {
      #cta-clip rect {
        transform-origin: 0px 0px;
        transform: scaleX(1); }
    }
  }
}
#HomeMask {
  position: absolute; top: 0; left: 0; width: 100%; height: 100%;
  background: #0A0A0A; }
</style>
